const React = require('react');
const noop = require('mn-utils/noop');
const getImageNaturalSizeByUrl
  = require('mn-utils/browser/getImageNaturalSizeByUrl');
const withState = require('../../../../utils/withState');
const {
  openPopupError,
} = require('../../../../emitters/popup');
const LoadingItemBase = require('./LoadingItemBase');

const SIZE_MB = 1024 * 1024;


module.exports = withState((setState, self, onMount) => {
  let _imageUrl;
  let _cancel = noop;
  let _stop;
  function updateImage() {
    getImageNaturalSizeByUrl(_imageUrl).then((size) => {
      _stop || setState({
        hasHorizontal: size[0] > size[1],
      });
    });
  }
  onMount(() => {
    const {
      props,
    } = self;
    const {
      file,
      apiUpload,
      maxFileSize,
    } = props;
    if (!file) {
      return;
    }
    const name = file.name;
    const onRemove = props.onRemove || noop;
    if (!apiUpload) {
      onRemove();
      openPopupError('The Upload method is not installed');
      return;
    }
    if (maxFileSize && file.size > maxFileSize) {
      onRemove();
      openPopupError(`The file size exceeds the ${(maxFileSize / SIZE_MB).toFixed(2)} MB limit`);
      return;
    }
    setState({
      progress: 0,
      loading: true,
    });
    const upload = apiUpload({
      data: file,
      docType: props.type,
      uploadUrl: props.uploadUrl,
    });
    upload.progress$.on((progress) => {
      _stop || setState({
        progress,
      });
    });
    _cancel = upload.promise.finally((error, response) => {
      if (_stop) {
        return;
      }
      response = response || {};
      const {
        id,
        url: image,
      } = response;
      const props = self.props;
      error
        ? (props.onRemove || noop)()
        : (props.onChange || noop)(id);
      setState({
        name,
        image,
        error,
        loading: false,
      });
    }).cancel;
    return () => {
      _stop = 1;
      _cancel();
    };
  });


  return (state, props) => {
    const Component = props.componentLoadingItem || LoadingItemBase;
    const image = state.image;
    image && _imageUrl !== image && updateImage(_imageUrl = image);


    return (<Component
      {...props}
      loading={state.loading}
      progress={state.progress}
      error={state.error}
      image={image}
      name={state.name || props.name}
      hasHorizontal={state.hasHorizontal}
      onClick={props.onClick}
      onRemove={props.onRemove || noop}
    />);
  };
});
